/**
 * sdg-dialog.js — the site's one popup (see assets/sdg-dialog.css)
 *
 *   [data-sdg-open="ID"]  opens <dialog id="ID" class="sdg-dialog"> as a modal
 *   [data-sdg-close]      inside a dialog closes it
 *   Backdrop click and Esc close it too.
 *
 * Page scroll is locked while a dialog is open. Each open/close dispatches a
 * bubbling "sdg-dialog:open" / "sdg-dialog:close" event on the dialog element,
 * so a host (the announcement bar, say) can pause its own behaviour.
 *
 * No dependencies. Safe to load more than once (guarded by a flag).
 */
(function () {
  if (window.__sdgDialog) return;
  window.__sdgDialog = true;

  var openCount = 0;

  function lockScroll(lock) {
    openCount = Math.max(0, openCount + (lock ? 1 : -1));
    document.documentElement.style.overflow = openCount > 0 ? 'hidden' : '';
  }

  function open(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    dialog.showModal();
    lockScroll(true);
    dialog.dispatchEvent(new CustomEvent('sdg-dialog:open', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-sdg-open]');
    if (opener) {
      event.preventDefault();
      open(document.getElementById(opener.getAttribute('data-sdg-open')));
      return;
    }

    var closer = event.target.closest('[data-sdg-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }

    // A click on the backdrop lands on the <dialog> element itself.
    if (event.target.matches && event.target.matches('dialog.sdg-dialog')) {
      event.target.close();
    }
  });

  // 'close' fires for Esc, the close button and the backdrop alike.
  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('dialog.sdg-dialog')) {
      lockScroll(false);
      event.target.dispatchEvent(new CustomEvent('sdg-dialog:close', { bubbles: true }));
    }
  }, true);

  // Public hook for scripts that want to open one programmatically
  // (the theme editor uses it to show an announcement's details when its block is selected).
  window.sdgDialog = { open: open };
})();
